import { FaFacebookSquare, FaYoutube, FaInstagram } from "react-icons/fa";
import Link from "next/link";
import { CompanyInformationsType } from "@/Types/GlobalTypes";

interface ComponentProps {
  informations: CompanyInformationsType
}

export default function SocialMediaField({ informations }: ComponentProps) {
  return (
    <div className="flex space-x-5 items-center justify-between text-white text-[16px] max-[750px]:hidden">
      {informations.facebookLink &&
        <Link target="blank" href={`${informations.facebookLink}`}>
          <FaFacebookSquare />
        </Link>
      }

      {informations.youtubeLink &&
        <Link href={`${informations.youtubeLink}`}>
          <FaYoutube />
        </Link>
      }

      {informations.instagramLink &&
        <Link href={`${informations.instagramLink}`}>
          <FaInstagram />
        </Link>
      }
    </div>
  )
}